package assets

import com.soywiz.korge.view.*
import com.soywiz.korim.format.*
import com.soywiz.korio.file.std.*

suspend fun loadCoinsAnimation(): SpriteAnimation {
    val bitmap = resourcesVfs["cash/coins.png"].readBitmap()

    return SpriteAnimation(
        spriteMap = bitmap,
        spriteWidth = 64,
        spriteHeight = 54,
        marginTop = 0,
        marginLeft = 0,
        columns = 6,
        rows = 1,
        offsetBetweenColumns = 0,
        offsetBetweenRows = 0,
    )
}

suspend fun loadDiamonds1Animation(): SpriteAnimation {
    val bitmap = resourcesVfs["cash/diamonds-1.png"].readBitmap()

    return SpriteAnimation(
        spriteMap = bitmap,
        spriteWidth = 64,
        spriteHeight = 54,
        marginTop = 0,
        marginLeft = 0,
        columns = 6,
        rows = 1,
        offsetBetweenColumns = 0,
        offsetBetweenRows = 0,
    )
}

suspend fun loadDiamonds2Animation(): SpriteAnimation {
    val bitmap = resourcesVfs["cash/diamonds-2.png"].readBitmap()

    return SpriteAnimation(
        spriteMap = bitmap,
        spriteWidth = 64,
        spriteHeight = 54,
        marginTop = 0,
        marginLeft = 0,
        columns = 6,
        rows = 1,
        offsetBetweenColumns = 0,
        offsetBetweenRows = 0,
    )
}

suspend fun loadDiamonds3Animation(): SpriteAnimation {
    val bitmap = resourcesVfs["cash/diamonds-3.png"].readBitmap()

    return SpriteAnimation(
        spriteMap = bitmap,
        spriteWidth = 64,
        spriteHeight = 54,
        marginTop = 0,
        marginLeft = 0,
        columns = 6,
        rows = 1,
        offsetBetweenColumns = 0,
        offsetBetweenRows = 0,
    )
}
